import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './ListSwitch.css';
//
// Вспомогательный компонент для раскрытия/закрытия списка категорий или стран.
//
const ListSwitch = ({ title, setListClass, count, border = false }) => {
    const { t } = useTranslation();
    const [ isOpen, setIsOpen ] = useState(true);

    const onClick = () => {
        if(isOpen) {
            setListClass('list-hide');
            setIsOpen(false);
        } else {
            setListClass('list-open');
            setIsOpen(true);
        }
    };

    return (
        <div
            onClick={() => onClick()}
            className={`ListSwitch ${border ? 'Border' : ''} ${isOpen ? 'Open' : ''}`}
        >
            <span>
                {t(title)}&nbsp;
                {count && <><small>({count})</small>&nbsp;</>}
            </span>
            <span className={isOpen ? 'rotate-open' : 'rotate-hide'}>
                <FontAwesomeIcon icon={faChevronDown}/>
            </span>
        </div>
    );
};

export default ListSwitch;
